<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="COPYRIGHT">© 2014 Chuck DeGroat<br/>All rights reserved<br/><br/>Published 2014 by<br/><span class="sc">Wm. B. Eerdmans Publishing Co.<br/></span>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge <span class="sc">cb3 9pu</span> U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">DeGroat, Chuck.<br/>Toughest people to love: how to understand, lead, and love the<br/>difficult people in your life — including yourself / Chuck DeGroat.<br/>pages   cm<br/>  Includes bibliographical references.<br/>  ISBN 978-0-8028-7143-5 (pbk.: alk. paper)<br/>  eISBN 978-1-4674-4040-0 (ePub)<br/>  eISBN 978-1-4674-3998-5 (Kindle)<br/>1. Conflict management — Religious aspects — Christianity.<br/>2. Interpersonal conflict — Religious aspects — Christianity.<br/>3. Interpersonal relations — Religious aspects — Christianity.<br/>4. Love — Religious aspects — Christianity. I. Title.<br/><br/>BV4597.53.C58D44 2014<br/>248.4 — dc23<br/>              2014002440</p>
<p class="CIP para-style-override-1"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?21e34938